const NOT_FOUND = -1;

export function binarySearchIndex<T>(
  array: Array<T>,
  search: (array: Array<T>, i: number) => number,
  start = 0,
  end = -1,
): number {
  let minIndex = start;
  let maxIndex = end < 0 ? array.length + end : end;
  let currentIndex = -1;

  while (minIndex <= maxIndex) {
    currentIndex = Math.floor((minIndex + maxIndex) / 2);
    const searchResult = search(array, currentIndex);

    if (searchResult > 0) {
      minIndex = currentIndex + 1;
    } else if (searchResult < 0) {
      maxIndex = currentIndex - 1;
    } else {
      return currentIndex;
    }
  }
  return NOT_FOUND;
}

export function binarySearchIndexLo<T>(
  array: Array<T>,
  search: (array: Array<T>, i: number) => number,
  start = 0,
  end = -1,
): number {
  let minIndex = start;
  let maxIndex = end < 0 ? array.length + end : end;
  let closeIndex = NOT_FOUND;

  while (minIndex <= maxIndex) {
    const midIndex = Math.floor((maxIndex + minIndex) / 2);
    if (minIndex === maxIndex) {
      return search(array, minIndex) >= 0 ? minIndex : closeIndex;
    }
    const searchResult = search(array, midIndex);
    if (searchResult < 0) {
      maxIndex = midIndex;
    } else {
      minIndex = midIndex + 1;
      closeIndex = midIndex;
    }
  }
  return NOT_FOUND;
}

export function binarySearchIndexHi<T>(
  array: Array<T>,
  search: (array: Array<T>, i: number) => number,
  start = 0,
  end = -1,
): number {
  let minIndex = start;
  let maxIndex = end < 0 ? array.length + end : end;
  let closeIndex = NOT_FOUND;

  while (minIndex <= maxIndex) {
    const midIndex = Math.floor((maxIndex + minIndex) / 2);
    if (minIndex === maxIndex) {
      return search(array, minIndex) <= 0 ? minIndex : closeIndex;
    }
    const searchResult = search(array, midIndex);
    if (searchResult > 0) {
      minIndex = midIndex + 1;
    } else {
      maxIndex = midIndex;
      closeIndex = midIndex;
    }
  }
  return NOT_FOUND;
}
